import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SharedService } from '../../../shared/shared.service';
import { API_MODULES } from '../../../core/api-modules';

@Component({
  selector: 'app-brands-slug',
  templateUrl: './brands-slug.component.html',
  styleUrls: ['./brands-slug.component.scss']
})
export class BrandsSlugComponent implements OnInit {
  products: any[] = [];
  loading: boolean = false;
  parseAvailableSizes(value: string | null | undefined): string[] {
    if (!value) return [];
    return String(value)
      .split(',')
      .map((v) => v.trim())
      .filter(Boolean);
  }

  constructor(
    private api: SharedService,
    private router: Router,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    const brandSlug = this.route.snapshot.paramMap.get('slug');
    const categorySlug =
      this.route.snapshot.paramMap.get('categorySlug') ||
      this.route.snapshot.queryParamMap.get('category_slug') ||
      '';

    if (brandSlug) {
      this.loadProducts(brandSlug, categorySlug);
    } else {
      // If no slug, fall back to all products or redirect
      this.router.navigate(['/brand']);
    }
  }

  async loadProducts(brandSlug: string, categorySlug: string): Promise<void> {
    try {
      this.loading = true;
      const encodedBrand = encodeURIComponent(brandSlug);
      const encodedCategory = encodeURIComponent(categorySlug);
      const res: any = categorySlug
        ? await this.api.getByBrandAndCategorySlugs(API_MODULES.PRODUCT, encodedBrand, encodedCategory)
        : await this.api.getByBrandSlugs(API_MODULES.PRODUCT, encodedBrand);

      if (res?.status === 'success' && res?.data) {
        this.products = res.data;
      }
    } catch (error) {
      console.error('Error loading products:', error);
    } finally {
      this.loading = false;
    }
  }

  getImg(path: string): string {
    if (!path) {
      return 'assets/no-image.png';
    }
    // If path already starts with http/https, return as is
    if (path.startsWith('http://') || path.startsWith('https://')) {
      return path;
    }
    // Otherwise, append to base URL
    return this.api.imageBase + path;
  }

  viewProduct(slugs: string): void {
    this.router.navigate(['/products-details', slugs]);
  }
}
